"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DidYouMean = void 0;
var DidYouMean_1 = require("./DidYouMean");
Object.defineProperty(exports, "DidYouMean", { enumerable: true, get: function () { return DidYouMean_1.DidYouMean; } });
